import {AuthContext} from "../context/authContext";
import {Navigate, Outlet} from "react-router-dom";
import {useContext} from 'react'

const PrivateRoutes = ({ userType }) => {
  const { user } = useContext(AuthContext);

  // console.log('routes - ', user && user.type, userType, user)

  if (!user) return <Navigate to="/login" />
  if (user.type === userType) return <Outlet />
  else {
    if (user.type === 'provider') return <Navigate to="/clients" />
    else if (user.type === 'client') return <Navigate to="/my_menus" />
  }
  return <Navigate to="/profile" />
}

export default PrivateRoutes
